import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ChevronDown } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from './ui/dropdown-menu';

// Minimal glass top bar that replaces the global KoLV nav on standalone
// business / shop pages. Keeps only a subtle "back to KoLV" link + language.
export const StandaloneHeader = ({ theme = 'dark' }) => {
  const { language, setLanguage } = useLanguage();
  const dark = theme === 'dark';

  const bar = dark
    ? 'bg-black/50 border-white/10'
    : 'bg-white/70 border-black/5';
  const link = dark
    ? 'text-white/60 hover:text-white'
    : 'text-black/55 hover:text-black';
  const pill = dark
    ? 'bg-white/10 text-white/80 hover:bg-white/20'
    : 'bg-black/5 text-black/70 hover:bg-black/10';

  const langs = [
    { code: 'lv', label: '🇱🇻 Latviešu' },
    { code: 'en', label: '🇬🇧 English' },
    { code: 'ru', label: '🇷🇺 Русский' },
  ];

  return (
    <header
      className={`sticky top-0 z-50 backdrop-blur-xl backdrop-saturate-150 border-b ${bar}`}
      data-testid="standalone-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-14 flex items-center justify-between">
        <Link
          to="/"
          className={`inline-flex items-center gap-2 text-sm font-medium transition-colors duration-200 ${link}`}
          data-testid="standalone-back-link"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>{language === 'ru' ? 'Назад на KoLV' : language === 'en' ? 'Back to KoLV' : 'Atpakaļ uz KoLV'}</span>
        </Link>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button
              className={`px-3 py-1.5 rounded-full text-sm font-medium flex items-center gap-1 transition-colors duration-200 ${pill}`}
              data-testid="standalone-lang-switcher"
            >
              {language.toUpperCase()}
              <ChevronDown className="w-3 h-3" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="min-w-[130px]">
            {langs.map((l) => (
              <DropdownMenuItem
                key={l.code}
                onClick={() => setLanguage(l.code)}
                className={language === l.code ? 'bg-[#F3F2EE] font-medium' : ''}
                data-testid={`standalone-lang-${l.code}`}
              >
                {l.label}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
};

export default StandaloneHeader;
